import { createSelector } from "@reduxjs/toolkit";

const videoTemplateDataSelector = createSelector(
  (state) => state.videoTemplateData,
  (a) => a
);

export default videoTemplateDataSelector;
